// Avisos do navegador do "Calendário Marketing Tarefas", em QUALQUER página do Central (montado no App). Não desenha nada.
// Só trabalha no navegador em que a pessoa ligou os avisos (botão Avisos na tela do calendário) e deu a permissão: aí confere as
// tarefas de hoje ao abrir, a cada 10 minutos e quando a aba volta a ficar visível. O cálculo (motor) só é baixado nesse caso.
import { useContext, useEffect } from 'react';
import { GlobalContext } from '../../lib/GlobalVar';
import { CHAVE, EVENTO, estadoAvisos } from './avisosConfig';

const INTERVALO = 10 * 60 * 1000;
const MINIMO_ENTRE = 2 * 60 * 1000; // aba que some e volta toda hora não refaz a conta a cada volta

export default function AvisosCalendarioMkt() {
    const { user } = useContext(GlobalContext);
    const solicitante = (user && (user.email || user.login || user.usuario)) || '';

    useEffect(() => {
        if (!solicitante) return undefined;
        let vivo = true;
        let relogio = null;
        let ultimo = 0;
        const roda = (forca) => {
            if (!vivo || estadoAvisos() !== 'ligado') return;
            if (!forca && Date.now() - ultimo < MINIMO_ENTRE) return;
            ultimo = Date.now();
            import('./avisosRodar').then((m) => (vivo ? m.verificaAvisos(solicitante) : null)).catch(() => {});
        };
        const arma = () => {
            clearInterval(relogio);
            relogio = null;
            if (estadoAvisos() !== 'ligado') return;
            roda(true);
            relogio = setInterval(() => roda(true), INTERVALO);
        };
        const outraAba = (e) => { if (!e.key || e.key === CHAVE) arma(); };
        const volta = () => { if (document.visibilityState === 'visible') roda(false); };
        arma();
        window.addEventListener(EVENTO, arma);
        window.addEventListener('storage', outraAba);
        document.addEventListener('visibilitychange', volta);
        return () => {
            vivo = false;
            clearInterval(relogio);
            window.removeEventListener(EVENTO, arma);
            window.removeEventListener('storage', outraAba);
            document.removeEventListener('visibilitychange', volta);
        };
    }, [solicitante]);

    return null;
}
